import LegalPageLayout from './LegalPageLayout'
import { Section } from './LegalProse'

// Website copy is mirrored in content/unimo-terms-of-service-draft.md.
export function TermsOfServicePage() {
    return (
        <LegalPageLayout
            title="unimo Website Terms of Service"
            effectiveDate="29 September 2026"
            lastUpdated="29 September 2026"
        >
            <Section heading="About these terms">
                <p>
                    These terms govern your use of <strong>getunimo.com</strong> (the &ldquo;website&rdquo;), operated by
                    CrossMoore AI Limited, a company registered in England and Wales (company number 15793460, registered
                    office 12c Two Locks, Hurst Business Park, Brierley Hill, West Midlands, DY5 1UU).
                </p>
                <p>By using this website, you agree to these terms. If you don&rsquo;t agree, please don&rsquo;t use the site.</p>
                <p>
                    <strong>These terms cover the website only.</strong> If you&rsquo;re a customer using the unimo product
                    itself, your use of unimo is governed by a separate commercial agreement (order form, subscription
                    agreement, or similar) entered into directly with CrossMoore - not by these website terms.
                </p>
            </Section>

            <Section heading="Using this website">
                <p>
                    This website is provided for the purpose of learning about unimo, exploring pricing, and getting in
                    touch with us. You agree to use it only for lawful purposes and not to:
                </p>
                <ul className="list-disc space-y-1 pl-5">
                    <li>attempt to gain unauthorised access to any part of the site or our systems</li>
                    <li>interfere with the site&rsquo;s operation (including via automated scraping, bots, or excessive requests)</li>
                    <li>use the site to transmit anything unlawful, harmful, or infringing</li>
                </ul>
            </Section>

            <Section heading="Intellectual property">
                <p>
                    Website content, including text, graphics, logos and software, is protected by intellectual property
                    rights. Rights in third-party material remain with its respective owners. You may view the website and
                    share links to it. Reuse of content must be permitted by law, an applicable licence or the rights holder.
                </p>
            </Section>

            <Section heading="Demonstrations and illustrative content">
                <p>
                    Videos, maps and interactive demonstrations may use illustrative models, simulated readings or
                    accelerated sequences. They demonstrate the software and are not surveys, approved designs,
                    engineering advice or evidence of actual site conditions. Verify information against appropriate
                    project records and professional advice before relying on it for operational decisions.
                </p>
            </Section>

            <Section heading="Website information and availability">
                <p>
                    This website and its content are provided &ldquo;as is.&rdquo; While we work to keep information
                    accurate and up to date, we don&rsquo;t guarantee that the site will be uninterrupted, error-free, or
                    that its content is complete or current at all times.
                </p>
                <p>
                    Nothing on this website constitutes a contractual offer regarding the unimo product itself. Pricing
                    shown is indicative and subject to change; any actual commercial terms are agreed separately.
                </p>
            </Section>

            <Section heading="Limitation of liability">
                <p>
                    Nothing in these terms excludes or limits liability for death or personal injury caused by negligence,
                    fraud or fraudulent misrepresentation, or any liability that cannot lawfully be excluded or limited.
                    Your statutory rights are not affected. If you use this website for business purposes, we exclude, to
                    the extent permitted by law, liability for loss of profit, revenue, business opportunity and indirect
                    or consequential loss arising from use of the website. Separate customer agreements govern liability
                    for paid products and services.
                </p>
            </Section>

            <Section heading="Links to other websites">
                <p>
                    This website may link to third-party websites. We&rsquo;re not responsible for the content or privacy
                    practices of those sites - please review their own terms and policies.
                </p>
            </Section>

            <Section heading="Changes to these terms">
                <p>
                    We may update these terms from time to time. The &ldquo;last updated&rdquo; date at the top will reflect
                    any changes. Continued use of the site after changes take effect means you accept the updated terms.
                </p>
            </Section>

            <Section heading="Governing law">
                <p>
                    These terms are governed by the laws of England and Wales, and any disputes will be subject to the
                    jurisdiction of the courts of England and Wales. If you are a consumer, these terms do not take away
                    any mandatory protections or right to bring proceedings in the courts of your home jurisdiction that
                    apply under the law.
                </p>
            </Section>

            <Section heading="Contact us">
                <p>
                    CrossMoore AI Limited
                    <br />
                    12c Two Locks, Hurst Business Park, Brierley Hill, West Midlands, DY5 1UU
                    <br />
                    Email: hello@getunimo.com
                </p>
            </Section>
        </LegalPageLayout>
    )
}

export default TermsOfServicePage
